var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookFilled = function SvgBookFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18v1a5 5 0 0 1-5 5H5a3 3 0 0 1 0-6zM6 16H5q-.306 0-.605.06A4.95 4.95 0 0 0 2 17.025V5A5 5 0 0 1 6 .1zM17 0a5 5 0 0 1 5 5v11H8V0z"
  })));
};
export default SvgBookFilled;